<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex justify-between">
        <div class="top-txt">
          <h4><b>Corporated Booking</b></h4>
        </div>
        <!-- <b-button disabled size="lg" class="border-solid border-2">Download Sample File</b-button> -->
        <base-button
          outline
          type="primary"
          @click="showaddbooking"
          class="flex px-6 py-1 mx-1"
          >+ Add Booking</base-button
        >
      </div>
      <b-input-group class="mt-6">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    showaddbooking() {
      this.$router.push({ name: "admin-addbooking" });
    },
  },
};
</script>

<style>
.justify-spacebetween {
  justify-content: space-between;
}
.btn-add-booking {
  border: 1px solid purple;
  padding: 10px 20px 10px 17px;
  color: purple;
  font-weight: 600;
}
</style>
